import React from "react";
import ToggleBlock from "../ToggleBlock";
import { Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Lista dinámica de formatos: viene del backend como faceta
// 'distribution__item__format' (prop `formats`), cada uno con { name, total }.
// Antes era un array fijo ['csv','html','json','tablero'] que mostraba formatos
// inexistentes (p. ej. HTML, sin datasets) y siempre daban 0 resultados.
function FormatFilter({ formats = [] }) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selected = urlParams.get('distribution__item__format');

    function filter(format) {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('distribution__item__format') === format) {
            queryParams.delete('distribution__item__format');
        } else {
            queryParams.set("distribution__item__format", format);
        }
        window.history.replaceState(null, null, "?" + queryParams.toString());
        window.location.reload();
    }

    // Sin formatos disponibles no mostramos el bloque (evita un "Formatos" vacío).
    if (!Array.isArray(formats) || formats.length === 0) {
        return null;
    }

    return (
        <div className="dc-search-facet-container">
            <ToggleBlock
                key={'formats'}
                title={'Formatos'}
                headingClasses={'sidenav-item sidenav-item-dropdown facet-block-format-inner'}
                innerClasses={'inner-fortmat-facets'}
                defaultClosed={true}
            >
                <div className="show-more-wrapper">
                    <ul className="show-more-container">
                        {formats.map((format) => {
                            var name = format.name;
                            var key = "formato-".concat(name);
                            var checked = selected === name;
                            return (<li className="dc-facet-option" key={key}>
                                <Input
                                    id={key}
                                    checked={checked}
                                    name={'formato'}
                                    type={'checkbox'}
                                    value={name}
                                    onChange={() => filter(name)} />
                                <Label
                                    htmlFor={key}
                                    className={'sidenav-item'}>
                                    <FontAwesomeIcon
                                        icon={["fas", checked ? "check-square" : "square"]}
                                        size={'1x'}
                                        role="presentation"
                                    />
                                    {name.toLocaleUpperCase()} ({format.total})
                                </Label>

                            </li>)
                        })}
                    </ul>
                </div>
            </ToggleBlock>
        </div>
    )
}

export default FormatFilter
